import { useNavigate, Navigate } from "react-router-dom";
import trpc from "../utils/trpc.js";
import { Button } from "../components/button/button.js";
import { FillContainerLoader } from "../components/loader.js";

function AssessmentWelcomeView() {
  const navigate = useNavigate();

  const { data, isLoading } = trpc.course.getAssessmentInfo.useQuery(undefined, { staleTime: Infinity });
  const { data: sessionData } = trpc.session.get.useQuery(undefined, { staleTime: Infinity });
  const displayName = sessionData?.userInfo.name;
  const courseTitle = sessionData?.courseInfo.courseTitle;

  if (isLoading) {
    return (
      <div className="h-screen">
        <FillContainerLoader delayMs={0} size="large" />
      </div>
    );
  }

  // If no assessment is required or it's already completed, redirect to home
  if (data && (!data.required || data.completed)) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="flex min-h-screen flex-col items-center justify-center px-6 py-16">
      <div className="w-full max-w-screen-lg">
        {/* Banner */}
        <div className="rounded-t-2xl border border-b-0 border-gray bg-gradient-to-br from-lac-leman/10 via-white/40 to-transparent px-10 py-12 md:px-14 md:py-16">
          {courseTitle && (
            <p className="mb-4 text-sm font-semibold uppercase tracking-[0.1em] text-lac-leman">{courseTitle}</p>
          )}
          <h1 className="text-5xl font-semibold leading-tight md:text-6xl">
            Welcome
            {displayName ? (
              <span>
                ,<br />
                {displayName}
              </span>
            ) : (
              ""
            )}
          </h1>
        </div>

        {/* Body card */}
        <div className="rounded-b-2xl border border-gray bg-white/60 px-10 py-8 shadow-xl shadow-lac-leman/10 md:px-14 md:py-10">
          <div className="flex flex-col gap-8 md:flex-row md:items-end md:justify-between">
            <div className="max-w-lg space-y-3">
              <p className="leading-relaxed text-midnight/70">
                Before accessing the course, you will complete a short assessment. The results will help us tailor the
                learning journey to best match your needs and experience level.
              </p>
              <p className="text-sm text-midnight/50">Once submitted, the assessment cannot be retaken.</p>
            </div>
            <Button filled="lac-leman" className="shrink-0 px-8 py-3 text-base" onClick={() => navigate("/assessment")}>
              Start Assessment
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export { AssessmentWelcomeView as Component };
